import { useApplication } from '@/hooks/useApplication';
import { useMetadataBlock } from '@/hooks/useMetadataBlock';
import { useUpdateNodes } from '@/hooks/useUpdateNodes';
import { ConfigurationEnum } from '@/types/metadata/metadata';
import { updateDetails } from '@/util/application';
import { Stack } from '@mui/material';
import { FC } from 'react';
import ParamRenderer from './parameter/ParamRenderer';
import SubroutineView from './subroutine/SubroutineView';

type DetailsViewProps = {
  id: number;
  parentId: number;
};

const DetailsView: FC<DetailsViewProps> = (props) => {
  const { application, setApplication } = useApplication();
  const { setUpdateNodes } = useUpdateNodes();
  const { metadataBlock } = useMetadataBlock();
  const configuration = metadataBlock?.configuration as ConfigurationEnum[];
  const details = application.blocks.details[props.id];
  const hasInterface = metadataBlock?.style === 'subroutine' || metadataBlock?.style === 'appstart';

  return (
    <>
      {hasInterface && <SubroutineView id={props.id} parentSubroutineId={props.parentId} />}
      <Stack gap={2} pt={1}>
        {configuration?.map((metaConfig, index) => {
          return (
            <ParamRenderer
              nodeId={props.id}
              parentId={props.parentId}
              key={`${metaConfig.value}.${index}`}
              configuration={metaConfig}
              initialValue={details}
              onChange={(...args) => {
                setApplication((previous) => {
                  const newDetails = { ...previous.blocks.details[props.id] };
                  args.forEach(([configValue, newValue]) => (newDetails[configValue] = newValue));

                  return updateDetails(props.id.toString(), newDetails, previous);
                });
                setUpdateNodes([props.id.toString()]);
              }}
            />
          );
        })}
      </Stack>
    </>
  );
};

export default DetailsView;
